export const SearchIcon = (props) => (
  <svg viewBox="0 0 42 42" {...props} fill={props.color} height={`${props.size || 42}`} width={`${props.size || 42}`}>
    <g>
      <circle fill="none" stroke={props.color} cx="19.4" cy="19.4" r="3.9" />
      <line fill="none" stroke={props.color} x1="22.1" y1="22.1" x2="26.5" y2="26.5" />
    </g>
  </svg>
);
